<template>
  <div class="bg-gray-300 min-h-full pt-20 p-6 pb-10 text-center">
    <transition name="slide-fade">
      <div
        class="p-8 max-w-xs w-full bg-white text-left rounded-lg inline-block shadow-xl"
        v-if="!loading"
      >
        <div class="px-10 flex flex-wrap content-end justify-center my-4 text-primary-300">
          <icon name="WaldigLogo" size="3rem" :settings="{ strokeWidth: 1, circle: true}" />
        </div>
        <div class="flex items-center justify-center" v-if="!logged">
          <div class="w-full">
            <h1 class="text-center text-3xl mb-0 tracking-wide">Admin</h1>
            <p class="text-center tracking-widest font-light mb-2">{{ $t("auth.login.login") }}</p>
            <login-form />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const LoginForm = require("@/modules/login/components/LoginForm").default;

export default {
  name: "LoginSite",
  mixins: [],
  data: () => ({}),
  computed: {
    logged: function() {
      return this.$store.getters["auth/logged"];
    }
  },
  methods: {},
  async created() {
    if (
      this.$store.getters["auth/token"] &&
      this.$store.getters["auth/token"] !== null
    ) {
      this.goTo("/");
      return;
    }

    await new Promise(resolve => setTimeout(resolve, 300));
    this.loaded();
  },
  components: {
    LoginForm
  }
};
</script>
